import axios, { clientRecords, extractData } from '@atheneum/api'
import _ from 'lodash'
import { computed, extendObservable } from 'mobx'

class ClientSearchStore {
  constructor () {
    extendObservable(this, {
      query: { page: 1 },
      records: [],
      loading: false,
      error: null,
      activeTab: 'All',
      total: null,
      autocompleteInput: '',
      accounts: computed(() => {
        const accountList = this.records.map(record => {
          return record.accounts.toJS()
        })
        return _.flatten(accountList)
      }),
      offices: computed(() => {
        const officeList = this.accounts.map(account => {
          return account.offices.toJS()
        })
        return _.flatten(officeList)
      })
    })
  }

  search (keyword) {
    this.loading = true
    this.total = null
    let payload = null
    if (keyword) {
      this.query.keyword = keyword
    }
    if (keyword === '') {
      this.query.keyword = null
    }
    if (this.query.keyword) {
      payload = {
        q: this.query.keyword,
        skip: 10 * (this.query.page - 1),
        size: 10
      }
    } else {
      payload = {
        skip: 10 * (this.query.page - 1),
        size: 10
      }
    }
    return axios
      .post('/api/client/records', payload)
      .then(res => {
        const responseData = extractData(res)
        let records = responseData.hits.hits.map(hit => {
          return hit._source
        })

        records = records.map(record => {
          const accounts = record.accounts.map(account => {
            return { ...account, expanded: false }
          })
          return { ...record, accounts, expanded: false }
        })

        this.records.replace(records)
        this.total = responseData.hits.total
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  autocompleteClientRecords = inputValue => {
    return clientRecords.autocomplete(inputValue)
  }

  clearSearch () {
    this.autocompleteInput = ''
  }

  changePage (page) {
    this.query.page = page
    this.search()
  }
}

export default ClientSearchStore
